module.exports = __webpack_public_path__ + "static/media/LLR_Logo.b788b0d5.svg";